const DotIcon = ({ className }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="7"
    height="8"
    viewBox="0 0 7 8"
    className={className}
  >
    <circle cx="3.5" cy="4" r="3.5"  />
  </svg>
);
export default DotIcon;
